


































































































import {
  defineComponent,
  onMounted,
  ref,
  computed,
  nextTick,
} from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import { CommodityPo } from '@/po/commodity';
import { formatContractName, getContractIframeUrl } from '@/views_v2/pre-apply-choose/utils';
import { Checkbox } from '@hb/coffee';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import CommonTitleTip from '../common-title-tip/index.vue';

export default defineComponent({
  components: {
    CommonTitleTip,
    Checkbox,
  },
  props: {
    channelList: {
      type: Array as PropType<CommodityPo.Info[]>,
      default: () => [],
      required: true,
    },
    isParallel: {
      type: Boolean,
      required: true,
    },
    /** 是否需要补充资料 */
    needSupplement: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['changeSelect'],
  setup(props, context) {
    const contractVersionTwoRef = ref<HTMLDivElement | null>(null);
    const contractListRef = ref<HTMLDivElement | null>(null);
    const contractShowRef = ref<HTMLDivElement | null>(null);
    const selectWrapShowRef = ref<HTMLDivElement | null>(null);
    /** 协议超过可视区（2行） */
    const isExceedMaxHeight = ref(false);
    /** 是否展开状态 */
    const isExpand = ref(false);

    /** 当前已勾选渠道 */
    const selectChannel = computed(() => props.channelList.filter((item) => item.isSelected));
    /** 从第四个元素（索引3）开始截取 */
    const channelListFromFourth = computed(() => props.channelList.slice(3));
    /** 当前展示协议对应渠道下标 */
    const activityChannelId = ref(props.channelList[0]?.commodityId);
    /** 当前选中协议下标 */
    const activityContractIndex = ref(0);
    /** 当前选中协议地址 */
    const activityContractUrl = ref((props.channelList[0]?.contractList?.[0]?.url) || '');

    /** 模式提示文案 */
    const moduleTip = computed(() => (
      props.isParallel
        ? '以下资方为您提供额度，为更好地提供服务，将同时为您发起申请，必要时您可主动选择资方。'
        : '以下资方为您提供额度，为更好地提供服务，若其中任何一家审批通过，则不再向其余机构提交申请。'
    ));
    /** 当前选中协议iframe地址 */
    const currentIframeUrl = computed(
      () => getContractIframeUrl(activityChannelId.value, activityContractUrl.value),
    );

    /**
     * 切换合同
     * @param channelId - 渠道ID
     * @param contractIndex - 合同索引编号
     * @param url - 合同文件URL地址
     * @returns void
     */
    const onChangeContract = (channelId: number, contractIndex: number, url:string) => {
      activityContractIndex.value = contractIndex;
      activityContractUrl.value = url;
      activityChannelId.value = channelId;
    };


    /**
     * 切换选中的渠道，并触发事件通知父组件
     * @param id 被切换的渠道ID
     * @returns void
     */
    const toggleSelect = (id: number) => {
      /** 如果勾选的渠道是当前选中的渠道，则取消选中并重置相关状态 */
      if (activityChannelId.value === id) {
        activityContractIndex.value = 0;
        activityChannelId.value = props.channelList[0].commodityId;
        activityContractUrl.value = (props.channelList[0]?.contractList?.[0]?.url) || '';
        if (contractListRef.value) {
          contractListRef.value.scrollTo(0, 0);
        }
      }
      context.emit('changeSelect', id);
    };

    /** 切换协议名称列表的展开状态，并执行相关操作。 */
    const toggleExpand = () => {
      isExpand.value = !isExpand.value;
      if (contractListRef.value) {
        contractListRef.value.scrollTo(0, 0);
      }
      ubtSetupPageButton('finance_loan_preApplyChoose_agreementsExpand');
    };

    /** 设置当前组件高度 */
    const setCurrentWrapHeight = () => {
      if (contractVersionTwoRef.value && selectWrapShowRef.value && props.channelList.length > 4) {
        /** 当前组件初始设置高度 */
        const height = contractVersionTwoRef.value.clientHeight;
        /** 勾选区高度 */
        const selectHeight = selectWrapShowRef.value.clientHeight;
        /** 重新设置当前组件的最小高度 */
        contractVersionTwoRef.value.style.minHeight = `${height + selectHeight - 13}px`;
      }
    };

    /** 计算协议名称是否超过最大高度 */
    const calcContractNameHeight = () => {
      if (contractListRef.value) {
        const element = contractListRef.value;
        // 滚动高度 > 容器可见高度 → 超过最大高度
        if ((element.scrollHeight - element.clientHeight) >= 5) {
          isExceedMaxHeight.value = true;
          ubtSetupModuleExpose('finance_loan_preApplyChoose_agreementsExpand');
        }
      }
    };

    /** 设置协议展示区初始化高度 */
    const setContractShowInitHeight = () => {
      if (contractShowRef.value) {
        /** 设置固定高度 */
        contractShowRef.value.style.height = `${contractShowRef.value.clientHeight}px`;// 固定高度
        /** 重置弹性布局，后续不随页面布局变化而弹性布局 */
        contractShowRef.value.style.flex = 'none';
      }
    };

    onMounted(() => {
      nextTick(() => {
        setCurrentWrapHeight();
        calcContractNameHeight();
        setContractShowInitHeight();
      });
    });

    return {
      activityChannelId,
      activityContractIndex,
      channelListFromFourth,
      selectChannel,
      currentIframeUrl,
      moduleTip,
      contractVersionTwoRef,
      contractListRef,
      contractShowRef,
      selectWrapShowRef,
      isExceedMaxHeight,
      isExpand,
      onChangeContract,
      formatContractName,
      toggleSelect,
      toggleExpand,
    };
  },
});
